import { FormItemDefinitionType, GenericFormField, GenericFormSection } from "models/propTypes/genericFormProps";
import useGetHasValueCount from "../forms/hooks/useGetHasValueCount";

function useFilterFieldTraversal<T extends Record<string, any>>(values?: T) {
  const { getHasValueCount } = useGetHasValueCount<T>(values);

  const hasAnyNonHiddenFieldSelected = (
    formItems: FormItemDefinitionType<T>,
    inheritedHidden?: boolean
  ): boolean => {
    const hasFromDefs = (
      defs?: Partial<Record<string, GenericFormField<any>>>,
      inherited?: boolean
    ): boolean => {
      if (!defs) return false;
      for (const [name, field] of Object.entries(defs)) {
        const isHidden = Boolean(inherited || field?.hideInReadOnlyRemovableView);
        if (field?.innerFields) {
          if (!isHidden && hasFromDefs(field.innerFields, false)) {
            return true;
          }
        } else if (!isHidden) {
          if (getHasValueCount(field as GenericFormField<T>, name) > 0) {
            return true;
          }
        }
      }
      return false;
    };

    if (Array.isArray(formItems)) {
      for (const section of formItems as GenericFormSection<T>[]) {
        if (
          hasFromDefs(
            section.innerFields as Partial<Record<string, GenericFormField<any>>>,
            inheritedHidden
          )
        ) {
          return true;
        }
      }
      return false;
    }

    return hasFromDefs(
      formItems as Partial<Record<string, GenericFormField<any>>>,
      inheritedHidden
    );
  };

  return { hasAnyNonHiddenFieldSelected };
}

export default useFilterFieldTraversal;


